import { render, staticRenderFns } from "./Profile-2.vue?vue&type=template&id=2f8e2cf0&"
import script from "./Profile-2.vue?vue&type=script&lang=js&"
export * from "./Profile-2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports